var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"notification"},[_c('top-bar-button',{staticStyle:{"cursor":"pointer"},on:{"button-click":_vm.handleOpenSideBar}}),(_vm.profile)?_c('chat-side-bar',{attrs:{"sb-model":_vm.ionaModel,"sb-id":_vm.ionaSBId,"profile":_vm.profile,"comm-with":"heartbeat"},on:{"close-clicked":_vm.handleSidebarClose}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }